import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

const DynamicItem = function DynamicItem({ element = '', onClick = () => {} }) {
  const intl = useIntl();

  const translatedValue =
    intl.messages[element.split('.')[1]?.toUpperCase()] ?? '';
  return (
    <ListItemButton
      key={element}
      id={element}
      onClick={() => onClick(`{${element}}`)}
      sx={{
        cursor: 'pointer',
      }}
      divider
    >
      <ListItemIcon>
        <AddCircleOutlineRoundedIcon />
      </ListItemIcon>
      <ListItemText primary={translatedValue} />
    </ListItemButton>
  );
};

DynamicItem.propTypes = {
  element: PropTypes.string,
  onClick: PropTypes.func,
};

export default DynamicItem;
